const MAIN_TIMELINE_MSG1 = 'Complete all steps of account activation to start accepting customer payments directly in your bank account.',
  MAIN_TIMELINE_MSG2 = 'However you will only get paid in your bank account upon successful account activation.';

const PROFILE_PATH = '/app/onboarding';
const API_PATH = '/status-timeline';

const TIMELINE_STAGES = {
  account_status: {
    label: 'Account Created',
    success: {
      stageMsg: "Congratulations! We have created your account"
    }
  },
  profile_status: {
    label: 'Complete your profile',
    success: {
      stageMsg: 'Congratulations! Your profile is now complete'
    },
    inProgress: {
      stageMsg: 'Tell us bit more about you',
      link: {
        text: 'Complete your profile',
        to: (onBoardingHost, careHost) => onBoardingHost + PROFILE_PATH
      }
    }
  },
  bank_status: {
    label: 'Bank Details',
    success: {
      stageMsg: 'Congratulations! Your bank account has been successfully linked'
    },
    inProgress: {
      stageMsg: 'Almost there ! Please verify your bank account details',
      link: {
        text: 'Verify bank account',
        to: (onBoardingHost, careHost) => onBoardingHost + PROFILE_PATH
      }
    },
    locked: {
      stageMsg: 'Link your bank account'
    },
    error: {
      stageMsg: 'Your have exhausted your verification attempts. Please contact support',
      link: {
        text: 'Contact support',
        to: (onBoardingHost, careHost) => careHost
      }
    },
    failure: {
      stageMsg: 'Your have exhausted your verification attempts. Please contact support',
      link: {
        text: 'Contact support',
        to: (onBoardingHost, careHost) => careHost
      }
    }
  }
};

 const COMPLETED = 'COMPLETED', ERROR = 'ERROR', FAILURE = 'FAILURE', IN_PROGRESS = 'IN_PROGRESS', LOCKED = 'LOCKED';


export {
  COMPLETED, ERROR, FAILURE, IN_PROGRESS, LOCKED,
  MAIN_TIMELINE_MSG1,
  MAIN_TIMELINE_MSG2,
  TIMELINE_STAGES,
  API_PATH
};
